import React from 'react';
import { startOnCanonicalApp } from './utils/authOrigin';
import { installAppleAuthDiagnostics } from './utils/appleAuthDiagnostics';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Amplify } from 'aws-amplify'; // must use aws-amplify, not @aws-amplify/core — sets up default auth providers
import awsconfig from './aws-exports';
import '@aws-amplify/auth/enable-oauth-listener';
import AppleAuthCallback from './components/AppleAuthCallback';
import 'bootstrap/dist/css/bootstrap.min.css';
import './custom-bootstrap-overrides.css';
import './index.css';
import App from './App';
import LocalSandboxPanel from './components/LocalSandboxPanel';
import PublicSite from './PublicSite';
import SupportPage from './SupportPage';
import PrivacyPage from './PrivacyPage';
import SmsConsent from './components/SmsConsent';
import reportWebVitals from './reportWebVitals';

// Navigate before configuring Amplify or mounting login: browser storage is per origin.
startOnCanonicalApp(window.location, () => {
  installAppleAuthDiagnostics();
  Amplify.configure(awsconfig);


  // Check if we're on the app subdomain
  const isAppSubdomain = window.location.hostname === 'app.tegratauto.com' ||
                         window.location.hostname === 'app-dev.tegratauto.com';

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <Router>
        <LocalSandboxPanel />
        <Routes>
          <Route path="/auth/callback" element={<AppleAuthCallback />} />
          {/* For app subdomains, skip public site and go straight to dashboard app */}
          {isAppSubdomain ? (
            <Route path="/*" element={<App />} />
          ) : (
            <>
              {/* Public marketing site */}
              <Route path="/" element={<PublicSite />} />

              {/* Customer Support Page (public) */}
              <Route path="/support" element={<SupportPage />} />

              {/* Privacy Policy (public) */}
              <Route path="/privacy" element={<PrivacyPage />} />

              {/* SMS Consent Page (public) */}
              <Route path="/sms-consent" element={<SmsConsent />} />

              {/* Dashboard and auth routes */}
              <Route path="/*" element={<App />} />
            </>
          )}
        </Routes>
      </Router>
    </React.StrictMode>
  );


  // Register service worker for push notifications
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
        .then(registration => {
          console.log('[SW] Service worker registered', { scope: registration.scope });
        })
        .catch(error => {
          console.warn('[SW] Service worker registration failed', error);
        });
    });
  }

  reportWebVitals();

});
